// extracted by mini-css-extract-plugin
module.exports = {"c106polj":"c106polj","icon":"icon"};